import React from 'react';
import { oneOf } from 'prop-types';

import BacnetProfileObjectsTable from './BacnetProfileObjectsTable';
import NiagaraProfileObjectsTable from './NiagaraProfileObjectsTable';

const TableTypes = {
    BacnetIP: BacnetProfileObjectsTable,
    Niagara:  NiagaraProfileObjectsTable
};

const ProfileObjectsTable = ({ onDeviceChange, type, ...props }) => {
    const Table = TableTypes[type];
    if (!Table) {
        return null;
    }
    return <Table {...props} />;
};

ProfileObjectsTable.propTypes = {
    type: oneOf(Object.keys(TableTypes)).isRequired
};

export default ProfileObjectsTable;
